import {Component, Input, OnInit} from '@angular/core';
import {NotificationMsg} from "../../../common/model/notificationMsg.model";
import {Action} from "../../../common/model/action.model";
import {UtilitiesService} from "../../../common/service/utilities.service";
import {NotificationsService} from "../../../common/service/notifications.service";

@Component({
  selector: 'app-alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.scss']
})
export class AlertsComponent implements OnInit {

  @Input() alert:NotificationMsg;

  constructor( private util:UtilitiesService,
               private notify: NotificationsService) { }

  ngOnInit() {
  }
    goTo(index){
       if (this.alert.actions[index]){
           this.util.goTo(this.alert.actions[index].link);
       }
    }

    close(){
      this.notify.clearAlerts(this.alert.id);
    }

}
